import Input from './Input';
import Select from './Select';
import { UserAgreement } from './UserAgreement';

export function CardPayment(props) {
	const {
		loadingCountries,
		countryOptions,
		setCountryOptions,
		selectedCountry,
		setSelectedCountry,
		loadingStates,
		getStates,
		stateOptions,
		setStateOptions,
		selectedState,
		setSelectedState,
		setDisabledState,
		disabledState,
		billingInfo,
		setBillingInfo,
		billingInfoErrors,
		checkValidation,
		profileLoading,
	} = props;

	const handleCountryChange = selected => {
		if (selected && selected.value?.length) {
			setSelectedState(undefined);
			setDisabledState(true);
			setStateOptions([]);
			getStates(selected.value);
			setSelectedCountry(selected);
		} else {
			setStateOptions([]);
			setSelectedCountry(undefined);
		}

		setBillingInfo(prev => ({ ...prev, billing_country: selected?.value }));
		checkValidation({ billing_country: selected?.value }, false);
	};

	const handleStateChange = selected => {
		if (selected && selected.value?.length) {
			setSelectedState(selected);
		} else {
			setSelectedState(undefined);
		}
		setBillingInfo(prev => ({ ...prev, card_state: selected?.value }));
		checkValidation({ card_state: selected?.value }, false);
	};

	const handleInput = (value, name) => {
		setBillingInfo(prev => ({ ...prev, [name]: value }));
		checkValidation({ [name]: value }, false);
	};

	return (
		<>
			<div className="wp-checkout-billing-address-wrapper">
				<h3 className=" wp-checkout-font-base wp-checkout-content-header ">
					Billing Address
				</h3>
				<div className="wp-checkout-billing-address-list wp-checkout-flex">
					<Input
						className="wp-checkout-billing-from-control"
						placeholder="Address Line*"
						value={billingInfo?.card_address}
						onChange={value => handleInput(value, 'card_address')}
						tabIndex={7}
						loading={profileLoading}
						error={billingInfoErrors?.card_address}
						tooltip={true}
						wrapperClassname="wp-checkout-col-50"
					/>
					<Input
						className="wp-checkout-billing-from-control"
						placeholder="Address Line 2"
						value={billingInfo?.card_address_2}
						onChange={value => handleInput(value, 'card_address_2')}
						tabIndex={8}
						loading={profileLoading}
						error={billingInfoErrors?.card_address_2}
						tooltip={true}
						wrapperClassname="wp-checkout-col-50"
					/>
					<Select
						options={countryOptions}
						isLoading={profileLoading || loadingCountries}
						onChange={handleCountryChange}
						isSearchable={true}
						isClearable={true}
						className="wp-checkout-billing-from-control from-control-padding-0"
						value={selectedCountry}
						placeholder={'Country*'}
						tabIndex={9}
						error={billingInfoErrors?.billing_country}
						tooltip={true}
						wrapperClassname="wp-checkout-col-50"
					/>

					<Select
						options={stateOptions}
						isLoading={profileLoading || loadingStates}
						onChange={handleStateChange}
						value={selectedState}
						isSearchable={true}
						isClearable={true}
						className="wp-checkout-billing-from-control from-control-padding-0"
						isDisabled={disabledState}
						placeholder={stateOptions.length ? 'State*' : 'State'}
						tabIndex={10}
						error={billingInfoErrors?.card_state}
						tooltip={true}
						wrapperClassname="wp-checkout-col-50"
					/>
					<Input
						className="wp-checkout-billing-from-control"
						placeholder="City*"
						value={billingInfo?.card_city}
						onChange={value => handleInput(value, 'card_city')}
						tabIndex={11}
						loading={profileLoading}
						tooltip={true}
						error={billingInfoErrors?.card_city}
						wrapperClassname="wp-checkout-col-50"
					/>
					<Input
						className="wp-checkout-billing-from-control"
						placeholder="ZIP / Postal Code*"
						value={billingInfo?.card_zip}
						onChange={value => handleInput(value, 'card_zip')}
						tabIndex={12}
						loading={profileLoading}
						tooltip={true}
						error={billingInfoErrors?.card_zip}
						wrapperClassname="wp-checkout-col-50"
					/>
				</div>
			</div>
		</>
	);
}
